<template>
  <div>
    <!-- 审核弹框 -->
    <el-dialog :title="title" width="730px" :visible.sync="isVisible" @close="closeModal">

      <el-form ref="form" :model="ruleForm" label-width="100px">
        <el-form-item :label="$t('审核')">

          <el-radio-group v-model="ruleForm.status">
            <el-radio :label="60" >{{ $t('同意') }}</el-radio>
            <el-radio :label="50" >{{ $t('驳回') }}</el-radio>
          </el-radio-group>

        </el-form-item>
        <el-form-item :label="$t('意见')">
          <el-input v-model="ruleForm.review_reason" type="textarea"></el-input>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn1" @click="closeModal()">{{ $t('取消') }}</el-button>
        <el-button type="primary" class="btn2" @click="submitPost" :loading="examineLoading">{{ $t('确定') }}</el-button>
      </span>

    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isVisible: false,
      ruleForm: {
        id: 0,
        status: 60,
        review_reason: "",
      }

    }
  },
  // 接收参数
  props: {
    examineLoading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
    id: {
      type: Number,
      default: 0
    }
  },
  methods: {
    
    openModal() {
      this.isVisible = true;
    },

    closeModal() {
      this.ruleForm = {
        id: 0,
        status: 60,
        review_reason: "",
      }
      this.isVisible = false;
    },

    submitPost() {
      this.ruleForm.id = this.id;
      this.$emit('poster-submitted', this.ruleForm);
    }
  }
}
</script>



<style lang="scss" scoped>
::v-deep() {
  .el-radio__original {
    display: none !important;
  }
  .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
    box-shadow: none !important;
  }
}

::v-deep() {
  .el-form-item__label {
    color: #040a16;
    font-size: 14px;
  }

  .el-radio__input.is-checked+.el-radio__label {
    // color: #040a16;
    font-size: 14px;
  }

  .el-form-item__content {
    padding-left: 16px;
  }


  .el-dialog__header {
    padding: 28px 32px 0px;
  }

  .el-dialog {
    max-height: 82vh;
    border-radius: 12px;
  }

  .el-dialog__body {
    margin-top: 20px;
    width: calc(100% - 20px);
    padding: 0px 12px 2px 32px;
    max-height: calc(82vh - 180px);
    overflow: hidden;
    overflow-y: scroll;

    &::-webkit-scrollbar {
      width: 6px;
      height: 4px;
      background: transparent;
      border-radius: 8px;
    }

    &::-webkit-scrollbar-thumb {
      background: #CF4325;
      border-radius: 8px;
    }
  }

  .el-dialog__footer {
    padding: 26px 36px 26px;
  }
}


.dialog-footer {

  .btn1,
  .btn2 {
    min-width: 76px;
    height: 36px;
    border-radius: 30px;
    padding: 0 16px;
    font-size: 14px;
  }

  .btn1 {
    background-color: #ffffff;
    border: 1px solid #ededed;

    &:hover {
      border: 1px solid #d9462f;
    }
  }

  .btn2 {
    background: linear-gradient(to right, #eb6f54, #d9462f);
    border: none;

    &:hover {
      background: linear-gradient(to right, #d9462f, #d9462f);
    }
  }
}
</style>